var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 46.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.79,.03C12.08-.58,.75,9.4,.04,21.86c-.36,6.33,1.92,12.69,6.25,17.44,4.28,4.7,10.04,7.4,16.2,7.62,.31,.01,.62,.02,.92,.02,13,0,23.06-9.64,23.57-22.77C47.48,11.06,37.94,.68,24.79,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M21.14,35.74c-.47,0-.9-.26-1.11-.68-1.48-2.9-4.31-6.14-7.57-8.67-.55-.42-.65-1.21-.22-1.75,.42-.55,1.21-.65,1.75-.22,2.83,2.19,5.3,4.8,7.03,7.41,3.66-7.35,8.79-13.85,14.02-17.68,.56-.41,1.34-.29,1.75,.27s.29,1.34-.27,1.75c-5.4,3.96-10.72,11-14.23,18.84-.2,.44-.63,.73-1.11,.74h-.03Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.5229de1b4e19c67d203a66df476a0c53.svg";
export { ForwardRef as ReactComponent };